import React from 'react';
import Footer from '../components/Footer';

const Team = () => {
  const syndicateMembers = [
    {
      name: 'SYED FAIZ HASAN',
      position: 'General Partner',
      image: "https://res.cloudinary.com/ditcmszc1/image/upload/v1769763266/Screenshot_2026-01-03_at_3.02.01_PM_zmmiqg_i5y2gj.png", // To be added later
      linkedin: "https://www.linkedin.com/in/syed-faiz-hasan-fz8174/" // To be added later
    },
    {
      name: 'UTKARSH SINGH',
      position: 'General Partner',
      image: "https://res.cloudinary.com/ditcmszc1/image/upload/v1769763266/Screenshot_2026-01-03_at_3.02.12_PM_nqlewn_venswr.png",
      linkedin: "https://www.linkedin.com/in/utkarsh-singh-a126b410b/"
    },
    {
      name: 'YASH RAJ',
      position: 'General Partner',
      image: "https://res.cloudinary.com/ditcmszc1/image/upload/v1769763266/Screenshot_2026-01-03_at_3.02.19_PM_sctqeq_tnfget.png",
      linkedin: "https://www.linkedin.com/in/yash-raj-46aa9a25b/"
    },
    {
      name: 'ALIZA FATIMA',
      position: 'General Partner',
      image: "https://res.cloudinary.com/ditcmszc1/image/upload/v1769763267/Screenshot_2026-01-03_at_3.02.26_PM_fga8yd_zq11uk.png",
      linkedin: "https://www.linkedin.com/in/aliza99/"
    },
    {
      name: 'PARITOSH SRIVASTAVA',
      position: 'General Partner',
      image: "https://res.cloudinary.com/ditcmszc1/image/upload/v1769763276/Screenshot_2026-01-03_at_3.02.31_PM_ibz1sm_hhajq7.png",
      linkedin: "https://www.linkedin.com/in/paritoshsahai/"
    },
    {
      name: 'SUNNY GARG',
      position: 'Anchor',
      image: "https://res.cloudinary.com/ditcmszc1/image/upload/v1769763270/Screenshot_2026-01-03_at_3.02.40_PM_cdzjtt_sgbi9x.png",
      linkedin: "https://www.linkedin.com/in/iamsunnygarg/"
    }
  ];

  const advisoryMembers = [
    {
      name: 'APOORVA KOTHARI',
      position: 'CEO/Partner',
      image: "https://res.cloudinary.com/ditcmszc1/image/upload/v1769763269/Screenshot_2026-01-03_at_3.02.50_PM_ct8jqk_v8mclc.png",
      linkedin: "https://www.linkedin.com/in/apoorva-kothari-6b117079/"
    }
  ];

  const hospitalityMembers = [
    {
      name: 'VARDAN KESARWANI',
      position: 'Partner',
      image: "https://res.cloudinary.com/ditcmszc1/image/upload/v1769763271/Screenshot_2026-01-03_at_3.02.59_PM_xfikqn_mqktjc.png",
      linkedin: "https://www.linkedin.com/in/vardankesarwani/"
    },
    {
      name: 'SANJEEV KESARWANI',
      position: 'Partner',
      image: "https://res.cloudinary.com/ditcmszc1/image/upload/v1769763270/Screenshot_2026-01-03_at_3.03.05_PM_b5i6ai_dusrki.png",
      linkedin: null
    },
    {
      name: 'SYED FAIZ HASAN',
      position: 'Partner',
      image: "https://res.cloudinary.com/ditcmszc1/image/upload/v1769763270/Screenshot_2026-01-03_at_3.03.14_PM_hynujs_rb7v9k.png",
      linkedin: "https://www.linkedin.com/in/syed-faiz-hasan-fz8174/"
    },
    {
      name: 'SACHIN GUPTA',
      position: 'Partner',
      image: "https://res.cloudinary.com/ditcmszc1/image/upload/v1769763271/Screenshot_2026-01-03_at_3.03.21_PM_nolgyc_gycq3s.png",
      linkedin: null
    }
  ];

  const TeamMemberCard = ({ member }) => (
    <div
      className="group cursor-pointer"
      onClick={() => member.linkedin && window.open(member.linkedin, '_blank')}
    >
      <div className="bg-grey/20 h-64 rounded-lg overflow-hidden mb-4 flex items-center justify-center border-2 border-grey/40 group-hover:border-lightBlue transition-all duration-300">
        {member.image ? (
          <img
            src={member.image}
            alt={member.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="text-6xl text-grey">👤</div>
        )}
      </div>
      <h3 className="text-lg font-bold text-black mb-1 text-center group-hover:text-lightBlue transition-colors duration-300">
        {member.name}
      </h3>
      <p className="text-sm text-gray-600 text-center">{member.position}</p>
    </div>
  );

  return (
    <div className="min-h-screen bg-white">
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl font-bold text-black mb-16 text-center opacity-0 animate-fade-in-up">TEAM</h1>

          {/* Imperier Syndicate */}
          <section className="mb-20">
            <h2 className="text-3xl font-bold text-black mb-10 text-center">
              IMPERIER SYNDICATE
            </h2>
            <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-8">
              {syndicateMembers.map((member, index) => (
                <TeamMemberCard key={index} member={member} />
              ))}
            </div>
          </section>

          {/* Imperier Advisory Services */}
          <section className="mb-20">
            <h2 className="text-3xl font-bold text-black mb-10 text-center">
              IMPERIER ADVISORY SERVICES
            </h2>
            <div className="grid md:grid-cols-3 gap-8 max-w-3xl mx-auto">
              {advisoryMembers.map((member, index) => (
                <div
                  key={index}
                  className={advisoryMembers.length === 1 ? 'md:col-start-2' : ''}
                >
                  <TeamMemberCard member={member} />
                </div>
              ))}
            </div>
          </section>

          {/* Brunch Club / Imperier Hospitality */}
          <section>
            <h2 className="text-3xl font-bold text-black mb-10 text-center">
              BRUNCH CLUB / IMPERIER HOSPITALITY
            </h2>
            <div className="grid md:grid-cols-4 gap-8 max-w-5xl mx-auto">
              {hospitalityMembers.map((member, index) => (
                <TeamMemberCard key={index} member={member} />
              ))}
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Team;

